import * as yup from 'yup';

export const initialValues = {
  billingAccountId: '',
  selectedStates: new Array<number>(),
  base64EncodedTaxPDF: '',
  taxNumber: '',
  exemption: 0,
  expirationDate: '',
  signedDate: '',
  signerName: '',
  signerTitle: '',
};

export const schema = yup.object().shape({
  selectedStates: yup
    .array()
    .min(1, 'State is required.')
    .required('State is required.'),
  base64EncodedTaxPDF: yup.string().required('PDF form is required.'),
  taxNumber: yup.string().required('Tax number is required.'),
  exemption: yup.number().min(1, 'Exemption type is required.'),
  expirationDate: yup.string().required('Valid expiration date is required.'),
  signedDate: yup.string().required('Valid effective date is required.'),
  signerName: yup.string().required('Signer name is required.'),
  signerTitle: yup.string().required('Signer title is required.'),
});

export type TaxExemptionFormValues = typeof initialValues;
